import Backbone from 'backbone';
import Tools from '../../services/Tools';
import BaseAPI from '../../services/BaseAPI';
var MobileDetect = require('mobile-detect');
const md = new MobileDetect(navigator.userAgent);

const MessageInputView = require('./input/MessageInputView');
const MessageInputModel = require('../../model/expand/input/MessageInputModel');
// chat list
const ChatListModel = require('../../model/expand/list/ChatListModel');
const ChatListView = require('./list/ChatListView');

const SettingModel = require('../../model/expand/setting/SettingModel');
const SettingView = require('./setting/SettingView');

const EmojiSmileysModel = require('../../model/expand/setting/EmojiSmileysModel');
const EmojiSmileysView = require('./setting/EmojiSmileysView');

const RatingModel = require('../../model/expand/setting/RatingModel');
const RatingView = require('./setting/RatingView');

const PopupModel = require('../../../components/model/PopupModel');
const PopupView = require('../../../components/view/PopupView');

const ModalboxModel = require('../../../components/model/ModalboxModel');
const ModalboxView = require('../../../components/view/ModalboxView');

const ConversationModel = require('../../model/expand/modal/ConversationModel');
const ConversationView = require('./modal/ConversationView');

const InformationView = require('./information/InformationView');
const InformationModel = require('../../model/expand/information/InformationModel');

const $ = Backbone.$;

module.exports = Backbone.View.extend({
  tagName: 'div',
  template() {
    const icon_setting = `${this.conf.domain}img/Setting.svg`;
    const icon_minimize = `${this.conf.domain}img/minimize.svg`;
    const logo = `${this.conf.domain}img/Logo.svg`;
    return `<div class="container" >
                <div class="header">
                    <div class="inner">
                        <div class="my_support mf">
                        </div>
                        <div class="wrap-ic setting-ic" style="margin-right: ${
                          !this.conf.userId ? '10px' : '5px'
                        }">
                          <img class="header-ic" src="${icon_setting}" >
                        </div>
                        ${
                          !this.conf.userId
                            ? `
                          <div class="wrap-ic minimize-ic">
                            <img class="header-ic" src="${icon_minimize}" >
                          </div>`
                            : ''
                        }
                    </div>
                </div>
                <div class='header_info mf'></div>
                <div class="info"></div>
                <div class="content">
                    <div class="conversation"></div>
                </div>
                <div class="footer"></div>
            </div>
            <div class="minimize"></div>`;
  },

  initialize(o) {
    _.bindAll(
      this,
      'renderContent',
      'handleCloseChatClick',
      'handleSubmitMessage',
      'handleRingtoneClick',
      'handleSaveClick',
      'handleEmojiPickerClick',
      'handleConversationClick',
      'endConversation',
      'receiveMessage',
      'initData',
      'updateContentHeight',
      'onInputFocus',
      'onInputBlur',
      'handleUploadFile',
      'handleUpdateAttachments',
      'handleSettingIconClick',
      'initChatView',
      'handleShowChanged'
    );
    const model = this.model;
    model.view = this;
    this.conf = o.config || {};
    this.avatar_default = `${this.conf.domain}img/default.png`;
    this.pfx = this.conf.stylePrefix || '';
    this.listenTo(model, 'open:change', this.handleShowChanged);
  },

  handleCloseChatClick(e) {
    const { model } = this;
    model.trigger('onChatClose');
  },

  endConversation() {
    const { model, conf } = this;
    const session_id = Tools.getSessionId(this.conf.domain_id);
    const userId = conf.userId || Tools.getUserId(this.conf.domain_id);
    model.set('send_cookie', true);
    var confix = {
      url: `${this.conf.domainAPI}/session/${session_id}/actions/end`,
      method: 'POST'
    };
    var headers = {
      cid: userId
    };
    BaseAPI.callAPI(
      confix,
      headers,
      response => {
        if (response.code == 200) {
          model.trigger('endConversation');
          conf.dataMess.data = [];
          model.set('support', true);
          setTimeout(() => {
            this.renderContent();
          }, 1000);
        }
      },
      error => {
        console.log('error', error);
      }
    );
  },

  handleRingtoneClick() {
    this.viewSetting.hide();
  },

  handleConversationClick(e) {
    const { conf, model } = this;
    const session_id = Tools.getSessionId(this.conf.domain_id);
    const _this = this;
    this.viewSetting.hide();

    const conversationModel = new ConversationModel(conf);
    const conversationView = new ConversationView({
      model: conversationModel,
      config: conf
    });

    const ratingModel = new RatingModel(conf);
    const ratingView = new RatingView({
      model: ratingModel,
      config: conf
    });
    let height_rat = 134;
    this.modalboxModel = new ModalboxModel(
      {
        width: conf.width - 70,
        height: height_rat,
        maxHeight: conf.height - 145
      },
      conf
    );
    this.modalboxView = new ModalboxView({
      model: this.modalboxModel,
      config: conf,
      target: $(this),
      contentView: conversationView
    });
    this.modalboxView.render();
    this.listenTo(conversationModel, 'cancelClick', function(e) {
      _this.modalboxView.hide();
    });
    this.listenTo(conversationModel, 'agreeClick', function(e) {
      if (session_id) {
        _this.modalboxView.hide();
        _this.endConversation();
        window.localStorage.setItem('greeting' + conf.domain_id, 0);
        Tools.setCookie('greeting' + this.config.domain_id, 0, 30);
        conf.greeting = 0;
        if (!model.get('support') && !conf.disable_review_chat) {
          const modalboxRatingModel = new ModalboxModel(
            {
              width: conf.width - 70,
              height: height_rat,
              maxHeight: conf.height - 145,
              bgcolor: 'rgba(0,0,0,0)'
            },
            conf
          );
          const modalboxRatingView = new ModalboxView({
            model: modalboxRatingModel,
            config: conf,
            target: $(this),
            contentView: ratingView
          });
          modalboxRatingView.render();
          _this.listenTo(ratingModel, 'agreeClick', function(e) {
            modalboxRatingView.hide();
            window.localStorage.setItem('session_id' + conf.domain_id, '');
            Tools.setCookie('session_id' + conf.domain_id, '', 30);
            _this.conf.session = '';
          });
        }
      }
    });
  },

  /**
   * handle save click
   */
  handleSaveClick(data) {
    const { $el, conf, model, informationView } = this;
    const userId =
      conf.userId || Tools.getUserId(conf.domain_id) || conf.currUserId;
    if (!userId) {
      return;
    }
    var formData = {
      name: data.name,
      email: data.email,
      phone: data.phoneNumber
    };
    var confix = {
      url: `${conf.domainAPI}/visitor/save`,
      method: 'POST',
      body: formData
    };
    var headers = {
      cid: userId,
      'Content-Type': 'application/json'
    };
    BaseAPI.callAPI(
      confix,
      headers,
      response => {
        if (response.code == 200) {
          this.saveUser(data);
        } else if (response.code == 422) {
          informationView.validateToServer(response.errors);
        }
      },
      error => {
        console.log('error', error);
      }
    );
  },

  /**
   * save user info
   * @param {*} data
   */
  saveUser(data) {
    const { conf, model, $el } = this;
    const userId = conf.userId || Tools.getUserId(conf.domain_id);
    if (data.name || data.email || data.phoneNumber) {
      Tools.setInfo(conf.domain_id);
      conf.dataMess.visitor = {
        name: data.name ? data.name : null,
        email: data.email ? data.email : null,
        phone: data.phoneNumber ? data.phoneNumber : null
      };
      const message = `${data.name ? `Họ và tên: ${data.name}\n` : ''}${
        data.email ? `E-mail: ${data.email}\n` : ''
      }${data.phoneNumber ? `Số điện thoại: ${data.phoneNumber}` : ''}`;
      // send message
      this.sendMessage(message);
    }
    this.updateHeaderInfo(conf.notify);
    this.chatListView.setDataLoaded();
    Tools.setTypeProfile(conf.domain_id);
    // remove information view
    this.infoContainer && this.infoContainer.remove();
    this.infoContainer = null;
    this.footer && this.footer.css('display', 'block');
  },

  /**
   * handle setting click
   */
  handleSettingIconClick(e) {
    const { conf } = this;
    const settingModel = new SettingModel(conf);
    const settingView = new SettingView({
      model: settingModel,
      config: conf
    });
    this.modelSetting = new PopupModel({ width: 200, height: 40 }, conf);
    this.viewSetting = new PopupView({
      model: this.modelSetting,
      config: conf,
      target: $(e.target),
      contentView: settingView
    });
    this.viewSetting.render();

    this.listenTo(
      settingModel,
      'conversationClick',
      this.handleConversationClick
    );
    this.listenTo(settingModel, 'ringtone', this.handleRingtoneClick);
  },

  /**
   * init chat
   */
  initChatView() {
    const { $el, conf } = this;
    this.chatModel = new ChatListModel(conf);
    this.chatListView = new ChatListView({
      model: this.chatModel,
      config: conf
    });
    $el.find('.conversation').append(this.chatListView.render().el);
  },

  /**
   * init information view
   */
  initInformationView() {
    const { $el, conf } = this;
    const informationModel = new InformationModel(conf);
    this.informationView = new InformationView({
      model: informationModel,
      config: conf
    });
    $el.find('.info').append(this.informationView.render().el);
    this.listenTo(informationModel, 'saveClick', this.handleSaveClick);
  },

  /**
   * init input view
   */
  initInputView() {
    const { $el, conf } = this;
    const inputModel = new MessageInputModel(conf);
    this.inputView = new MessageInputView({
      model: inputModel,
      config: conf
    });
    $el.find('.footer').append(this.inputView.render().el);

    this.listenTo(inputModel, 'onSubmit', this.handleSubmitMessage);
    this.listenTo(inputModel, 'onUploadFile', this.handleUploadFile);
    this.listenTo(inputModel, 'onOpenSticker', this.handleStickerOpen);
    this.listenTo(
      inputModel,
      'onUpdateAttachments',
      this.handleUpdateAttachments
    );
    this.listenTo(inputModel, 'onHeightChanged', this.updateContentHeight);
    this.listenTo(inputModel, 'onFocus', this.onInputFocus);
    this.listenTo(inputModel, 'onBlur', this.onInputBlur);
  },

  /**
   * handle input focus
   * if is mobile then update height content when input
   */
  onInputFocus() {
    if (!md.mobile()) {
      return;
    }
    this.content.css({ height: 'auto' });
    setTimeout(() => {
      this.updateContentHeight();
    }, 250);
  },

  /**
   * handle input blur
   */
  onInputBlur() {
    if (!md.mobile()) {
      return;
    }
    this.content.css({ height: 'auto' });
    setTimeout(() => {
      this.updateContentHeight();
    }, 250);

    setTimeout(() => {
      this.popupViewEmoji && this.popupViewEmoji.updatePosition();
    }, 300);
  },

  /**
   * update header info
   */
  updateHeaderInfo(message = null) {
    const { conf } = this;
    this.headerInfo.html(
      `<span class="header_info_span mf">${message || conf.notify_info}</span>`
    );
  },

  /**
   * update supporter
   */
  updateSupporter() {
    const { avatar_default, conf } = this;
    if (conf.supporter) {
      this.headerInfo.html('').css('display', 'none');
      this.mySupport.html(`
        <img class="avatar" src="${Tools.getFavicon() ||
          avatar_default}" width="30" height="30">
        <div class="nameSupport mf"> ${conf.name_website}</div>
      `);
    }
  },

  /**
   * update content height
   */
  updateContentHeight() {
    const { $el, conf } = this;
    const headerHeight = parseInt(this.header.height());
    const headerInfoHeight = parseInt(this.headerInfo.height());
    const footerHeight = parseInt(this.footer.height());
    let frameHeight = conf.height;
    if (md.mobile()) {
      frameHeight = parseInt($el.height());
    }
    const contentHeight =
      frameHeight - headerHeight - headerInfoHeight - footerHeight;
    this.content.css({ height: `${contentHeight}px` });
    // console.log('updateContentHeight');
  },

  /**
   * Receive message
   */
  receiveMessage(msg) {
    const { $el, model, conf, avatar_default } = this;
    const type_profiles = Tools.getTypeProfile(this.conf.domain_id);
    if (
      msg.sender.sender_type === 'DOMAIN' &&
      conf.require_info_user &&
      type_profiles != 2
    ) {
      this.showInfoContainer();
      // this.informationView && this.informationView.handleShowGreeting(msg);
      // hien thi header di kem form thong tin
      this.updateHeaderInfo();
    } else {
      this.infoContainer && this.infoContainer.remove();
      this.infoContainer = null;
      this.footer && this.footer.css('display', 'block');
    }

    this.chatListView.receiveMessage(msg, null, 1);
    const cid = this.conf.userId || Tools.getUserId(this.conf.domain_id);
    if (cid && msg.sender.sender_type === 'SUPPORTER') {
      this.updateSupporter();
      model.set('support', false);
    }
    // update content height
    setTimeout(() => {
      this.updateContentHeight();
    }, 50);
  },

  /**
   * update height info
   */
  updateInfoHeight() {
    if (!this.infoContainer) {
      return;
    }
    const headerHeight =
      parseInt(this.header.height()) + parseInt(this.headerInfo.height());
    let frameHeight = this.conf.height;
    if (md.mobile()) {
      frameHeight = parseInt(this.$el.height());
    }
    const height = frameHeight - headerHeight;
    this.infoContainer.css({ height: `${height}px`, top: `${headerHeight}px` });
  },
  /**
   * show info container
   */
  showInfoContainer() {
    const { $el, conf } = this;
    if (!this.infoContainer) {
      return;
    }
    setTimeout(() => {
      this.infoContainer.css({ display: 'block' });
      this.footer.css({ display: 'none' });
      this.updateInfoHeight();
    }, 50);
  },

  /**
   * update message from visitor
   */
  updateMessage(dataMsg) {
    this.chatListView.updateMessage(dataMsg);
  },

  handleEmojiPickerClick(sticker) {
    this.inputView.setEmoji(sticker);
    this.popupViewEmoji.hide();
  },

  /**
   * submit message
   */
  handleSubmitMessage(msg) {
    this.sendMessage(msg);
  },

  sendMessage(msg) {
    const { $el, conf, model } = this;
    const userId = conf.userId || Tools.getUserId(conf.domain_id);
    const messageData = this.buildMessageData(msg);
    model.set('send_cookie', false);

    model.trigger('sendMessage', {
      cookie_id: userId,
      message: msg,
      id: messageData.id,
      team_id: conf.teamID
    });
    // add un send message
    this.chatListView.receiveMessage(messageData, null, 1);
  },

  /**
   * handle upload files
   */
  handleUploadFile(fileData) {
    const messageData = this.buildMessageData(undefined, fileData);
    this.chatListView.receiveMessage(messageData, null, 1);
  },

  /**
   * handle update file attachments
   */
  handleUpdateAttachments(attachments, id, mid, response) {
    // this.emitAllVisitor
    this.model.trigger('emitAllVisitor', response);

    this.chatListView.updateAttachments(attachments, id, mid);
  },

  /**
   * build message data
   */
  buildMessageData(msg, file = null) {
    const { conf } = this;
    const timestamp = new Date().getTime() / 1000;
    const attachment = file && {
      type: file.type,
      image: file.image,
      name: file.name
    };
    const data = {
      id: timestamp,
      idFile: file && file.idFile,
      timestamp: timestamp,
      attachments: [attachment],
      message: msg,
      time: Tools.convertTime(timestamp),
      domain: conf.domain,
      type: 1,
      sender: {
        sender_type: 'VISITOR',
        id: conf.userId || Tools.getUserId(conf.domain_id)
      },
      mid: timestamp,
      read: true,
      status: 1
    };
    return data;
  },

  handleStickerOpen(target) {
    const { conf } = this;
    const emojiSmileysModel = new EmojiSmileysModel(conf);
    const emojiSmileysView = new EmojiSmileysView({
      model: emojiSmileysModel,
      config: conf
    });
    this.popupModelEmoji = new PopupModel({ width: 250, height: 150 }, conf);
    this.popupViewEmoji = new PopupView({
      model: this.popupModelEmoji,
      config: conf,
      target: target,
      className: 'emoji',
      contentView: emojiSmileysView
    });
    this.popupViewEmoji.render();

    this.listenTo(emojiSmileysModel, 'emojiClick', this.handleEmojiPickerClick);
  },

  renderContent() {
    const { $el, model, conf } = this;

    $el.html(this.template());
    if (md.mobile()) {
      $el.find('.container').css('border-radius', '0px');
    }

    this.mySupport = $el.find('.my_support');
    this.header = $el.find('.header');
    this.headerInfo = $el.find('.header_info');
    this.footer = $el.find('.footer');
    this.content = $el.find('.content');
    this.infoContainer = $el.find('.info');

    model.set('support', true);
    const type_profiles = Tools.getTypeProfile(this.conf.domain_id);
    if (conf.require_info_user && type_profiles != 2) {
      this.infoContainer.css({ display: 'block' });
    }

    $el.find('.minimize-ic').on('click', this.handleCloseChatClick);
    $el.find('.setting-ic').on('click', this.handleSettingIconClick);

    // init chat view
    this.initChatView();
    // init information view
    this.initInformationView();
    // init input
    this.initInputView();

    // set color
    this.header.css({
      'background-color': conf.header_color,
      color: conf.text_header_color
    });
    this.mySupport.css({
      'background-color': conf.header_color,
      color: conf.text_header_color
    });
    this.headerInfo.css({
      'background-color': conf.header_color,
      color: conf.text_header_color
    });
  },

  /**
   * init data
   */
  initData() {
    if (this.hadInitData) {
      return;
    }
    const { $el, model, conf, avatar_default } = this;
    const dataMess = conf.dataMess;
    const type_profiles = Tools.getTypeProfile(this.conf.domain_id);
    if (conf.require_info_user && type_profiles != 2) {
      // hien thi form thong tin
      this.showInfoContainer();
      //hien thi header di kem form thong tin
      this.updateHeaderInfo();
    } else {
      this.updateHeaderInfo(conf.notify);
    }
    if (
      dataMess &&
      dataMess.data &&
      dataMess.data.length === 1 &&
      dataMess.data[0].sender.sender_type === 'DOMAIN' &&
      type_profiles != 2 &&
      conf.require_info_user
    ) {
      this.showInfoContainer();
      //hien thi header di kem form thong tin
      this.updateHeaderInfo();
    }
    // get new massage
    this.setDataMessage(dataMess);
    this.hadInitData = true;
  },

  /**
   * set data message
   */
  setDataMessage(dataMess) {
    const { conf, $el, model } = this;
    const loaded = this.chatModel.get('dataLoaded');
    if (loaded) {
      return;
    }

    this.chatListView.dataConnect(dataMess.data);
    this.updateSupporter();

    setTimeout(() => {
      this.updateContentHeight();
    }, 150);
  },

  /**
   * update data message
   */
  updateDataMessage(dataMess) {
    this.chatListView.dataConnect(dataMess ? dataMess.data : []);
    this.updateSupporter();

    setTimeout(() => {
      this.updateContentHeight();
    }, 100);
  },

  /**
   * show chat panel
   */
  show() {
    this.model.set('open', true);
    this.chatModel.set('showChat', true);
    this.$el.css({ display: 'block', opacity: 0.35, transform: 'scale(0.95)' });
    this.initData();
    this.updateContentHeight();

    setTimeout(() => {
      this.$el.css({ transform: 'scale(1)', opacity: 1 });
      setTimeout(() => {
        this.chatListView.scrollToBottom();
      }, 150);
    }, 0);
    setTimeout(() => {
      this.updateInfoHeight();
      this.updateContentHeight();
    }, 110);
    setTimeout(() => {
      this.updateInfoHeight();
      this.updateContentHeight();
    }, 150);
    setTimeout(() => {
      this.updateInfoHeight();
      this.updateContentHeight();
    }, 200);
  },

  /**
   * hide chat
   */
  hide() {
    this.model.set('open', false);
    this.chatModel.set('showChat', false);
    this.$el.css({ transform: 'scale(0.95)', opacity: 0.2 });
    setTimeout(() => {
      this.$el.css({ display: 'none' });
    }, 50);
  },

  /**
   * show change handler
   * @param {show} model
   * @param {*} val
   * @param {*} options
   */
  handleShowChanged(model, val, options) {
    if (val) {
      this.show();
      return;
    }
    this.hide();
  },

  render() {
    const { $el, model, conf } = this;
    $el.attr({ class: `${this.pfx}chat` }).css({ display: 'none' });
    if (md.mobile()) {
      $el.css({
        height: '100%',
        width: '100%',
        padding: '0px',
        bottom: '0px',
        left: '0px',
        top: '0px',
        right: '0px',
        'z-index': 10
      });
    }
    if (!md.mobile()) {
      const bottom = conf.size_icon + 25;
      $el.css({ height: `calc(100% - ${bottom}px)`, bottom: `${bottom}px)` });
    }
    if (conf.chat_box_position === 7 || conf.chat_box_position === 4) {
      $el.css({ 'transform-origin': 'bottom left' });
    }
    this.renderContent();

    if (md.mobile()) {
      setInterval(() => {
        this.updateContentHeight();
      }, 1000);
    }

    return this;
  }
});
